import React from "react";
import { MdError, MdWarning, MdInfo, MdCheckCircle } from "react-icons/md";

const severities = {
  error: {
    className: "bg-red-50 text-red-800 border-red-200",
    icon: <MdError className="text-red-600" size={20} />,
  },
  warning: {
    className: "bg-orange-50 text-orange-800 border-orange-200",
    icon: <MdWarning className="text-orange-600" size={20} />,
  },
  info: {
    className: "bg-blue-50 text-blue-800 border-blue-200",
    icon: <MdInfo className="text-blue-600" size={20} />,
  },
  success: {
    className: "bg-green-50 text-green-800 border-green-200",
    icon: <MdCheckCircle className="text-green-600" size={20} />,
  },
};

const Alert = ({ severity = "info", className = "", children, ...rest }) => {
  const { className: severityClassName, icon } = severities[severity] || severities.info;

  return (
    <div
      role="alert"
      className={`flex items-start gap-2 rounded-lg border px-4 py-2.5 text-sm ${severityClassName} ${className}`}
      {...rest}
    >
      <span className="mt-0.5 shrink-0">{icon}</span>
      <div className="min-w-0">{children}</div>
    </div>
  );
};

export default Alert;
